(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpAnnounceReady) return;
    window.__dpAnnounceReady = true;

    function setDuration(bar) {
      var speed = parseFloat(bar.dataset.speed) || 40;
      var group = bar.querySelector('.dp-ab__group');
      if (!group) return;
      var width = group.getBoundingClientRect().width;
      if (width > 0) bar.style.setProperty('--dp-ab-duration', (width / speed).toFixed(2) + 's');
    }

    function init(root) {
      (root || document).querySelectorAll('[data-dp-ab]').forEach(setDuration);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-dp-ab-toggle]');
      if (!btn) return;
      var bar = btn.closest('[data-dp-ab]');
      var paused = btn.getAttribute('aria-pressed') !== 'true';
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
      if (bar) bar.classList.toggle('is-paused', paused);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { init(); }, 200);
    });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { init(); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpFaqReady) return;
    window.__dpFaqReady = true;

    document.addEventListener('input', function (e) {
      var input = e.target;
      if (!input.matches || !input.matches('[data-dp-faq-search]')) return;
      var root = input.closest('[data-dp-faq]');
      if (!root) return;
      var term = input.value.trim().toLowerCase();
      var shown = 0;

      root.querySelectorAll('[data-dp-faq-item]').forEach(function (item) {
        var match = !term || item.textContent.toLowerCase().indexOf(term) > -1;
        item.hidden = !match;
        if (match) shown++;
      });

      root.querySelectorAll('[data-dp-faq-category]').forEach(function (cat) {
        var next = cat.nextElementSibling;
        var visible = false;
        while (next && !next.hasAttribute('data-dp-faq-category')) {
          if (next.hasAttribute('data-dp-faq-item') && !next.hidden) { visible = true; break; }
          next = next.nextElementSibling;
        }
        cat.hidden = !visible;
      });

      var empty = root.querySelector('[data-dp-faq-empty]');
      if (empty) empty.hidden = shown > 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpQuickAddReady) return;
    window.__dpQuickAddReady = true;

    function getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function setLoading(btn, on) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      btn.disabled = on;
    }

    function showError(form, msg) {
      var card = form.closest('.dp-prod__card');
      var el = card && card.querySelector('[data-dp-error]');
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    function announce(form, msg) {
      var root = form.closest('.dp-prod');
      var live = root && root.querySelector('[data-dp-live]');
      if (live) live.textContent = msg;
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-dp-add-form]')) return;
      e.preventDefault();

      var btn = Array.prototype.find.call(form.elements, function (el) {
        return el.type === 'submit' && el.offsetParent !== null;
      }) || document.activeElement;

      var cart = getCart();
      var formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      showError(form, '');
      setLoading(btn, true);

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            showError(form, response.description || response.message || 'Something went wrong. Please try again.');
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'dp-quick-add',
              productVariantId: formData.get('id'),
              cartData: response
            });
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

          if (btn && btn.dataset.labelAdded) {
            var label = btn.querySelector('.dp-prod__btn-label');
            if (label) {
              label.textContent = btn.dataset.labelAdded;
              setTimeout(function () { label.textContent = btn.dataset.labelAdd; }, 2000);
            }
          }
          announce(form, (btn && btn.dataset.labelAdded) || 'Added to cart');
        })
        .catch(function () {
          showError(form, 'Something went wrong. Please try again.');
        })
        .finally(function () {
          setLoading(btn, false);
        });
    });

    document.addEventListener('change', function (e) {
      var select = e.target;
      if (!select.matches || !select.matches('[data-dp-variant]')) return;
      var opt = select.options[select.selectedIndex];
      var card = select.closest('.dp-prod__card');
      if (!card || !opt) return;

      var price = card.querySelector('[data-dp-price]');
      if (price) {
        price.innerHTML = '';
        var now = document.createElement('span');
        now.className = 'dp-prod__price-now' + (opt.dataset.compare ? ' dp-prod__price-now--sale' : '');
        now.textContent = opt.dataset.price;
        price.appendChild(now);
        if (opt.dataset.compare) {
          var was = document.createElement('s');
          was.className = 'dp-prod__price-compare';
          was.textContent = opt.dataset.compare;
          price.appendChild(was);
        }
      }

      var available = opt.dataset.available === 'true';
      card.querySelectorAll('[data-dp-add-btn]').forEach(function (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('.dp-prod__btn-label');
        if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSold;
      });
    });

    function updateSlider(track) {
      var wrap = track.closest('[data-dp-slider]');
      if (!wrap) return;
      var max = track.scrollWidth - track.clientWidth;
      var prev = wrap.querySelector('[data-dp-prev]');
      var next = wrap.querySelector('[data-dp-next]');
      var bar = wrap.querySelector('[data-dp-progress]');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (bar) {
        var visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = Math.max(visible * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 / Math.max(visible, 0.01) - 1) * 100) + '%)';
      }
      wrap.classList.toggle('dp-prod__wrap--scrollable', max > 2);
    }

    function initSliders(root) {
      (root || document).querySelectorAll('.dp-prod [data-dp-track]').forEach(updateSlider);
    }

    document.addEventListener('click', function (e) {
      var arrow = e.target.closest && e.target.closest('[data-dp-prev], [data-dp-next]');
      if (!arrow) return;
      var wrap = arrow.closest('[data-dp-slider]');
      var track = wrap && wrap.querySelector('[data-dp-track]');
      if (!track) return;
      var dir = arrow.hasAttribute('data-dp-next') ? 1 : -1;
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    });

    document.addEventListener('scroll', function (e) {
      if (e.target.matches && e.target.matches('.dp-prod [data-dp-track]')) updateSlider(e.target);
    }, true);

    window.addEventListener('resize', function () { initSliders(); });
    document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSliders(); });
    } else {
      initSliders();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpFooterReady) return;
    window.__dpFooterReady = true;

    var mq = window.matchMedia('(max-width: 749px)');

    function syncGroups() {
      document.querySelectorAll('.dp-footer').forEach(function (footer) {
        var accordion = footer.classList.contains('dp-footer--accordion');
        footer.querySelectorAll('[data-dp-footer-group]').forEach(function (group) {
          if (accordion && mq.matches) {
            if (!group.dataset.dpTouched) group.removeAttribute('open');
          } else {
            group.setAttribute('open', '');
          }
        });
      });
    }

    document.addEventListener('click', function (e) {
      var summary = e.target.closest && e.target.closest('.dp-footer__heading');
      if (summary) {
        var footer = summary.closest('.dp-footer');
        var accordion = footer && footer.classList.contains('dp-footer--accordion');
        if (!accordion || !mq.matches) {
          e.preventDefault();
          return;
        }
        summary.parentElement.dataset.dpTouched = 'true';
      }

      var topBtn = e.target.closest && e.target.closest('[data-dp-footer-top]');
      if (topBtn) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
        var main = document.getElementById('MainContent');
        if (main) {
          main.setAttribute('tabindex', '-1');
          main.focus({ preventScroll: true });
        }
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-dp-footer-country]')) e.target.form.submit();
    });

    if (mq.addEventListener) mq.addEventListener('change', syncGroups);
    document.addEventListener('shopify:section:load', syncGroups);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncGroups);
    } else {
      syncGroups();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-signature-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpSpotReady) return;
    window.__dpSpotReady = true;

    function getCart() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function goToSlide(root, index) {
      var track = root.querySelector('[data-dp-spot-track]');
      if (!track) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    function syncThumbs(track) {
      var root = track.closest('[data-dp-spot]');
      if (!root || !track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      root.querySelectorAll('[data-dp-spot-thumb]').forEach(function (t) {
        if (Number(t.dataset.dpSpotThumb) === index) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest && e.target.closest('[data-dp-spot-thumb]');
      if (thumb) {
        goToSlide(thumb.closest('[data-dp-spot]'), Number(thumb.dataset.dpSpotThumb));
        return;
      }
      var qtyBtn = e.target.closest && e.target.closest('[data-dp-spot-qty]');
      if (qtyBtn) {
        var input = qtyBtn.parentElement.querySelector('input[name="quantity"]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 1) + Number(qtyBtn.dataset.dpSpotQty);
        input.value = Math.max(1, next);
      }
    });

    document.addEventListener('scroll', function (e) {
      if (e.target.matches && e.target.matches('[data-dp-spot-track]')) syncThumbs(e.target);
    }, true);

    document.addEventListener('change', function (e) {
      var select = e.target;
      if (!select.matches || !select.matches('[data-dp-spot-variant]')) return;
      var root = select.closest('[data-dp-spot]');
      var opt = select.options[select.selectedIndex];
      if (!root || !opt) return;

      var price = root.querySelector('[data-dp-spot-price]');
      if (price) {
        price.innerHTML = '';
        var now = document.createElement('span');
        now.className = 'dp-spot__price-now';
        now.textContent = opt.dataset.price;
        price.appendChild(now);
        if (opt.dataset.compare) {
          var was = document.createElement('s');
          was.className = 'dp-spot__price-compare';
          was.textContent = opt.dataset.compare;
          price.appendChild(was);
          var saveTpl = root.querySelector('[data-dp-spot-save-label]');
          if (saveTpl && opt.dataset.save) {
            var save = document.createElement('span');
            save.className = 'dp-spot__save';
            save.textContent = saveTpl.dataset.dpSpotSaveLabel + ' ' + opt.dataset.save;
            price.appendChild(save);
          }
        }
      }

      var available = opt.dataset.available === 'true';
      var btn = root.querySelector('[data-dp-spot-add]');
      if (btn) {
        btn.disabled = !available;
        var label = btn.querySelector('.dp-spot__btn-label');
        if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSold;
      }

      if (opt.dataset.mediaId) {
        var slides = Array.prototype.slice.call(root.querySelectorAll('[data-media-id]'));
        var idx = slides.findIndex(function (sl) { return sl.dataset.mediaId === opt.dataset.mediaId; });
        if (idx > -1) goToSlide(root, idx);
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-dp-spot-form]')) return;
      e.preventDefault();

      var btn = form.querySelector('[data-dp-spot-add]');
      var errorEl = form.querySelector('[data-dp-spot-error]');
      var live = form.querySelector('[data-dp-spot-live]');
      var cart = getCart();
      var formData = new FormData(form);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
      }

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) {
            if (errorEl) {
              errorEl.textContent = response.description || response.message || 'Something went wrong. Please try again.';
              errorEl.hidden = false;
            }
            return;
          }
          if (!cart) {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'dp-spotlight',
              productVariantId: formData.get('id'),
              cartData: response
            });
          }
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

          if (btn) {
            var label = btn.querySelector('.dp-spot__btn-label');
            if (label && btn.dataset.labelAdded) {
              label.textContent = btn.dataset.labelAdded;
              setTimeout(function () { label.textContent = btn.dataset.labelAdd; }, 2000);
            }
          }
          if (live) live.textContent = (btn && btn.dataset.labelAdded) || 'Added to cart';
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (btn) {
            btn.classList.remove('is-loading');
            btn.setAttribute('aria-busy', 'false');
            btn.disabled = false;
          }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp-spin-wheel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__dpSpinReady) return;
    window.__dpSpinReady = true;

    var STORE_KEY = 'dp-spin-state';
    var PENDING_KEY = 'dp-spin-pending';

    function readState() {
      try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
    }
    function writeState(obj) {
      try { localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) {}
    }
    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function SpinPopup(root) {
      this.root = root;
      this.config = JSON.parse(root.querySelector('[data-dp-spin-config]').textContent);
      this.modal = root.querySelector('[data-dp-spin-modal]');
      this.overlay = root.querySelector('.dp-spin__overlay');
      this.wheel = root.querySelector('[data-dp-spin-wheel]');
      this.form = root.querySelector('.dp-spin__form');
      this.teaser = root.querySelector('[data-dp-spin-teaser]');
      this.live = root.querySelector('[data-dp-spin-live]');
      this.rotation = 0;
      this.isOpen = false;
      this.spinning = false;
      this.designMode = root.hasAttribute('data-design-mode');
      this.bind();
      if (this.designMode) {
        this.showTeaser();
      } else {
        this.schedule();
      }
    }

    SpinPopup.prototype.bind = function () {
      var self = this;
      this.root.addEventListener('click', function (e) {
        if (e.target.closest('[data-dp-spin-close]')) { self.close(true); }
        if (e.target.closest('[data-dp-spin-open]')) { self.open(); }
        if (e.target.closest('[data-dp-spin-teaser-close]')) { self.hideTeaser(true); }
        if (e.target.closest('[data-dp-spin-copy]')) { self.copy(e.target.closest('[data-dp-spin-copy]')); }
      });
      if (this.form) {
        this.form.addEventListener('submit', function (e) { self.submit(e); });
      }
      this.modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { self.close(true); }
        if (e.key === 'Tab') { self.trapFocus(e); }
      });
    };

    SpinPopup.prototype.schedule = function () {
      var self = this;
      var c = this.config;
      var state = readState();

      if (this.resumePending()) return;
      if (!c.enabled) return;

      // Signed up already: no popup and no tab, ever.
      if (state.status === 'won' || state.status === 'submitted') return;

      // Side tab: always visible (until they sign up or hide it), or only after closing.
      if (c.teaserMode === 'always' || state.status === 'dismissed') this.showTeaser();

      // The popup opens on its own only once per visitor.
      if (state.status === 'dismissed') return;
      if (!c.mobile && window.matchMedia('(max-width: 749px)').matches) return;

      setTimeout(function () {
        if (!self.isOpen) self.open();
      }, Math.max(c.delay, 0.6) * 1000);
    };

    SpinPopup.prototype.open = function () {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      this.hideTeaser(false);
      this.overlay.hidden = false;
      this.modal.hidden = false;
      this.root.classList.add('is-open');
      document.documentElement.classList.add('dp-spin-lock');
      var email = this.modal.querySelector('[data-dp-spin-email]');
      var target = email && !email.closest('[hidden]') ? email : this.modal;
      setTimeout(function () { target.focus(); }, 60);
    };

    SpinPopup.prototype.close = function (userDismissed) {
      if (!this.isOpen || this.spinning) return;
      this.isOpen = false;
      this.overlay.hidden = true;
      this.modal.hidden = true;
      this.root.classList.remove('is-open');
      document.documentElement.classList.remove('dp-spin-lock');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();

      if (this.designMode) { this.showTeaser(); return; }
      var state = readState();
      if (state.status === 'won' || state.status === 'submitted') return;
      if (userDismissed) {
        state.status = 'dismissed';
        state.at = Date.now();
        writeState(state);
      }
      this.showTeaser();
    };

    SpinPopup.prototype.showTeaser = function () {
      if (!this.teaser || !this.config.teaser || this.isOpen) return;
      if (!this.config.teaserMobile && window.matchMedia('(max-width: 749px)').matches) return;
      if (!this.designMode) {
        var state = readState();
        if (state.teaserHidden || state.status === 'won' || state.status === 'submitted') return;
      }
      this.teaser.hidden = false;
    };
    SpinPopup.prototype.hideTeaser = function (forever) {
      if (!this.teaser) return;
      this.teaser.hidden = true;
      if (forever && !this.designMode) {
        var state = readState();
        state.teaserHidden = true;
        writeState(state);
      }
    };

    SpinPopup.prototype.trapFocus = function (e) {
      var nodes = Array.prototype.filter.call(
        this.modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && !el.closest('[hidden]') && el.offsetParent !== null; }
      );
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    SpinPopup.prototype.pick = function () {
      var prizes = this.config.prizes;
      var total = prizes.reduce(function (sum, p) { return sum + Math.max(0, p.weight); }, 0);
      var r = Math.random() * total;
      for (var i = 0; i < prizes.length; i++) {
        r -= Math.max(0, prizes[i].weight);
        if (r < 0) return i;
      }
      return prizes.length - 1;
    };

    SpinPopup.prototype.setStep = function (name) {
      this.modal.querySelectorAll('[data-dp-spin-step]').forEach(function (step) {
        step.hidden = step.getAttribute('data-dp-spin-step') !== name;
      });
    };

    // Uses a real (native) form submit so Shopify's built-in spam protection
    // accepts it and the customer is saved. The page reloads, then the popup
    // reopens and spins automatically (see resumePending).
    SpinPopup.prototype.submit = function (e) {
      var email = this.form.querySelector('[data-dp-spin-email]');
      var error = this.form.querySelector('[data-dp-spin-error]');
      if (!email.checkValidity()) {
        e.preventDefault();
        error.textContent = email.validationMessage || 'Please enter a valid email.';
        error.hidden = false;
        email.setAttribute('aria-invalid', 'true');
        email.focus();
        return;
      }
      error.hidden = true;
      email.removeAttribute('aria-invalid');

      var index = this.pick();
      var prize = this.config.prizes[index];
      var tags = this.form.querySelector('[data-dp-spin-tags]');
      if (tags) tags.value = [this.config.tags, 'wheel: ' + prize.label].filter(Boolean).join(', ');

      var submitBtn = this.form.querySelector('[data-dp-spin-submit]');
      submitBtn.classList.add('is-loading');

      // Theme Editor preview: spin without saving a real customer.
      if (this.designMode) {
        e.preventDefault();
        submitBtn.disabled = true;
        this.spinTo(index);
        return;
      }

      try { localStorage.setItem(PENDING_KEY, String(index)); } catch (err) {}
      writeState({ status: 'submitted', label: prize.label, code: prize.code, at: Date.now() });
      // No preventDefault: the browser submits the form to Shopify normally.
    };

    SpinPopup.prototype.cleanUrl = function () {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      url.hash = '';
      window.history.replaceState(null, '', url.pathname + url.search);
    };

    SpinPopup.prototype.resumePending = function () {
      var pending = null;
      try { pending = localStorage.getItem(PENDING_KEY); } catch (e) {}
      if (pending === null) return false;

      var posted = window.location.search.indexOf('customer_posted=true') > -1;
      var serverError = this.root.querySelector('[data-dp-spin-server-error]');

      // Shopify rejected the email (e.g. invalid): reopen so they can fix it.
      if (!posted && serverError) {
        try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
        writeState({});
        this.open();
        return true;
      }
      if (!posted) return false;

      try { localStorage.removeItem(PENDING_KEY); } catch (e) {}
      var index = parseInt(pending, 10);
      if (isNaN(index) || !this.config.prizes[index]) return false;
      this.cleanUrl();
      this.open();
      this.spinTo(index);
      return true;
    };

    SpinPopup.prototype.spinTo = function (index) {
      var self = this;
      var count = this.config.prizes.length;
      var seg = 360 / count;
      var mid = (index + 0.5) * seg;
      var jitter = (Math.random() - 0.5) * seg * 0.6;
      var current = this.rotation % 360;
      var land = (360 - mid - jitter + 360) % 360;
      var extra = (land - current + 360) % 360;
      var spins = reducedMotion() ? 1 : Math.max(1, this.config.turns || 3);
      this.rotation = this.rotation + spins * 360 + extra;

      this.spinning = true;
      this.setStep('spinning');
      this.root.classList.toggle('dp-spin--quick', reducedMotion());
      this.wheel.style.transform = 'rotate(' + this.rotation + 'deg)';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        self.spinning = false;
        self.showResult(index);
      }
      this.wheel.addEventListener('transitionend', finish, { once: true });
      var ms = reducedMotion() ? 900 : parseFloat(getComputedStyle(this.root).getPropertyValue('--dp-sp-duration')) * 1000 + 400;
      setTimeout(finish, ms || 6000);
    };

    SpinPopup.prototype.showResult = function (index) {
      var prize = this.config.prizes[index];
      this.modal.querySelector('[data-dp-spin-prize]').textContent = prize.label;
      var codeWrap = this.modal.querySelector('[data-dp-spin-code-wrap]');
      codeWrap.hidden = !prize.code;
      this.modal.querySelector('[data-dp-spin-code]').textContent = prize.code || '';
      this.setStep('result');
      if (this.live) this.live.textContent = prize.label + (prize.code ? '. Code: ' + prize.code : '');

      var closeBtn = this.modal.querySelector('.dp-spin__close');
      if (closeBtn) closeBtn.focus();

      if (this.designMode) return;
      writeState({ status: 'won', label: prize.label, code: prize.code, at: Date.now() });
      this.hideTeaser(false);

      if (this.config.autoApply && prize.code) {
        var root = this.config.root || '/';
        if (root.slice(-1) !== '/') root += '/';
        fetch(root + 'discount/' + encodeURIComponent(prize.code), { credentials: 'same-origin' }).catch(function () {});
      }
    };

    SpinPopup.prototype.copy = function (btn) {
      var code = this.modal.querySelector('[data-dp-spin-code]').textContent;
      function done() {
        btn.textContent = btn.dataset.labelCopied;
        setTimeout(function () { btn.textContent = btn.dataset.labelCopy; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        ta.remove();
      }
    };

    SpinPopup.prototype.reset = function () {
      this.spinning = false;
      this.setStep('form');
      var btn = this.form && this.form.querySelector('[data-dp-spin-submit]');
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    };

    var instances = {};
    function init(scope) {
      (scope || document).querySelectorAll('[data-dp-spin]').forEach(function (root) {
        if (root.__dpSpin) return;
        root.__dpSpin = new SpinPopup(root);
        instances[root.dataset.sectionId] = root.__dpSpin;
      });
    }

    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:select', function (e) {
      var inst = instances[e.detail.sectionId];
      if (inst) { inst.reset(); inst.open(); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var inst = instances[e.detail.sectionId];
      if (inst) { inst.spinning = false; inst.close(false); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var inst = instances[e.detail.sectionId];
      if (inst) inst.open();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
